import { Stack, Typography } from "@mui/material";
import type { FC } from "react";
import dayjs from "../../dayjs";
import sortBy from "lodash/sortBy";

interface Props {
  readonly rooms: {
    readonly resources: {
      readonly product: { readonly id: string; readonly name: string };
      readonly option: { readonly id: string; readonly name: string };
      readonly date: string;
    }[];
    readonly count: number;
  }[];
}

const CombinationResources: FC<Props> = ({ rooms }) => {
  const resources = rooms.flatMap(({ resources, count }) => resources.map((r) => ({ ...r, count })));
  const sortedResources = sortBy(resources, (r) => r.date);
  return (
    <Stack direction="column">
      <Typography variant="subtitle2">Układ dotyczy następujących zasobów</Typography>
      {sortedResources.map((r, idx) => (
        <Typography
          key={idx}
        >{`${dayjs(r.date).format("DD.MM.YYYY")} ${r.product.name} ${r.option.name} ${r.count} szt.`}</Typography>
      ))}
    </Stack>
  );
};

export default CombinationResources;
